import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      subscription: {}
    },
    pagination: {}
  },

  getters: {
    currentPaypalSubscriptions: (state) => state.list,
    currentPaypalSubscription: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    paypalSubscriptionsFetched(state, { paypalSubscriptions }) {
      state.list = paypalSubscriptions
    },

    paypalSubscriptionFetched(state, { paypalSubscription }) {
      state.item = paypalSubscription
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchPaypalSubscriptions({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/paypal-subscriptions',
        params: {
          page,
          ...buildFilters(filters)
        }
      })

      const paypalSubscriptions = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('paypalSubscriptionsFetched', { paypalSubscriptions })
      commit('paginationFetched', { pagination })
    },

    async fetchPaypalSubscription({ commit }, paypalSubscriptionId) {
      const response = await fetch({ url: `/api/admin/paypal-subscriptions/${paypalSubscriptionId}` })
      const paypalSubscription = await deserialize(response.data)

      commit('paypalSubscriptionFetched', { paypalSubscription })
    }
  }
}
